export const FORGOT_PASSWORD_FORM_NAME = 'forgot-password';
export const SET_PASSWORD_FORM_NAME = 'set-password';



// WEBPACK FOOTER //
// ./src/forgot-password/constants.js